import { Controller } from "@hotwired/stimulus"
import { Tooltip } from "bootstrap"

export default class extends Controller {
  highlightSegment(event) {
    const row = event.currentTarget.closest("[data-segment-key]")
    if (!row) return

    const { segmentKey } = row.dataset
    if (!segmentKey) return

    this.element.classList.add("enum-breakdown-chart--legend-hover")

    this.barElementsFor(segmentKey).forEach((element) => {
      element.classList.add("is-highlighted")
      this.showTooltip(element)
    })
  }

  clearHighlight() {
    this.element.classList.remove("enum-breakdown-chart--legend-hover")
    this.element.querySelectorAll(".is-highlighted").forEach((element) => {
      element.classList.remove("is-highlighted")
    })
    this.hideAllTooltips()
  }

  barElementsFor(segmentKey) {
    return this.element.querySelectorAll(
      `.enum-breakdown-chart__bar-link[data-segment-key="${segmentKey}"],` +
      `.enum-breakdown-chart__bar-slot[data-segment-key="${segmentKey}"]`
    )
  }

  showTooltip(element) {
    if (!element.matches("[data-bs-toggle='tooltip']")) return

    Tooltip.getOrCreateInstance(element, { container: "body" }).show()
  }

  hideAllTooltips() {
    this.element.querySelectorAll("[data-bs-toggle='tooltip']").forEach((element) => {
      Tooltip.getInstance(element)?.hide()
    })
  }
}
